import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme: any) => {
  return {
    container: { 
      flex: 1,
    },
  };
});

export default useStyles;
